/* ==========================================================================
   FlatWine — ticker.js
   Marquee continuo. Duplica el grupo de contenido para que el loop
   sea perfecto, y calcula la duración a partir del ancho real para que
   la velocidad sea constante sin importar cuánto contenido haya.
   ========================================================================== */

(function () {
  'use strict';

  var PIXELS_PER_SECOND = 55;

  /* Una barra puede tener más de una vía; hoy el tema usa una, pero cada
     vía se prepara y se cronometra por separado, porque su duración sale de
     su propio ancho. */
  function initTicker(ticker) {
    var vias = ticker.querySelectorAll('[data-ticker-track]');
    for (var v = 0; v < vias.length; v++) initVia(ticker, vias[v], v);
  }

  function initVia(ticker, track, indice) {
    var group = track.querySelector('[data-ticker-group]');
    if (!track || !group) return;

    // El keyframe recorre -50%, así que hacen falta exactamente dos copias.
    // Que el grupo cubra la pantalla es cosa del CSS (min-width: 100vw): con
    // cinco chips en 1308 px sobre una pantalla de 1815 se veía el mismo chip
    // dos veces a la vez, y eso no se arregla añadiendo copias, se arregla
    // repartiendo los que hay a lo ancho.
    if (track.children.length === 1) {
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    function syncSpeed() {
      // La mitad de la pista, que es lo que recorre el keyframe -50%.
      var width = track.scrollWidth / 2;
      if (!width) return;
      /* La segunda vía va más rápida porque dos marquesinas a la misma
         velocidad en direcciones opuestas se leen como un error de reflejo y
         no como dos capas.

         La referencia corre 43 s contra 15 s, una proporción de 2.8. Copiar
         esa PROPORCIÓN sobre una pista más corta que la suya daba 8 s, que en
         absoluto marea. Manda el tiempo absoluto: 1.6 deja la vía rápida
         cerca de los 14 s de la referencia y la diferencia se sigue viendo. */
      var velocidad = indice === 0 ? PIXELS_PER_SECOND : PIXELS_PER_SECOND * 1.6;
      track.style.setProperty(
        '--ticker-duration', (width / velocidad).toFixed(1) + 's'
      );
    }

    syncSpeed();
    /* El listener de resize sobrevive al nodo cuando el editor reemplaza la
       sección. Se desengancha solo al descubrir que su pista ya no está en el
       documento, en vez de acumularse sobre nodos desconectados. */
    function alRedimensionar() {
      if (!track.isConnected) {
        window.removeEventListener('resize', alRedimensionar);
        return;
      }
      syncSpeed();
    }
    window.addEventListener('resize', alRedimensionar, { passive: true });

    // Las fuentes cambian el ancho al cargar; recalcular evita un salto.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncSpeed);
    }
  }

  var yaIniciados = new WeakSet();

  /* El control de pausa. Alterna el atributo que el CSS mira y mantiene el
     nombre accesible en sintonía con lo que el botón hará al pulsarlo. */
  function initPausa(ticker) {
    var boton = ticker.querySelector('[data-ticker-pause]');
    if (!boton || boton.dataset.fwListo) return;
    boton.dataset.fwListo = '1';
    boton.addEventListener('click', function () {
      var pausada = ticker.hasAttribute('data-paused');
      if (pausada) ticker.removeAttribute('data-paused');
      else ticker.setAttribute('data-paused', '');
      boton.setAttribute('aria-label', pausada ? 'Pausar los anuncios' : 'Reanudar los anuncios');
    });
  }

  function init() {
    document.querySelectorAll('[data-ticker]').forEach(initPausa);
    document.querySelectorAll('[data-ticker]').forEach(function (el) {
      if (yaIniciados.has(el)) return;
      yaIniciados.add(el);
      initTicker(el);
    });
  }

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
